const BREAD_CRUMB_URL = 'j/breadcrumb';

export default {
    BREAD_CRUMB_URL,
};
